// App.js
import React from 'react';
import { Box } from '@mui/material';
import styled from '@emotion/styled';
import BackgroundVideo from './Components/BackgroundVideo';
import CopyrightNotice from './Components/CopyrightNotice';
import './App.css';

import poster from './images/Sequence01-first.webp'
import video from './videos/Sequence01.webm'
import logo from './images/Priority_6_Logo.webp'

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1,
  width: '90%',
});

const LogoImage = styled('img')({
  width: '100%',
  maxHeight: '50vh',
  objectFit: 'contain',
});

const App = () => {
  return (
    <div className="app">
      <BackgroundVideo posterSrc={poster} videoSrc={video} />
      <StyledBox>
        <LogoImage src={logo} alt="Priority 6 Logo" className="logo" />
      </StyledBox>
      <CopyrightNotice />
    </div>
  );
};

export default App;